<!-- data-cs-name-owner keeps the capture-cover directive from naming this track button after the host's text, which is only the value and tick numbers -->
<button cs-capture-cover data-cs-name-owner (click)="onTrackClick($event)"></button>
<div #trackEl class="track" [attr.disabled]="disabled ? '' : null" [attr.dragging]="dragging ? '' : null">
  <div class="thumb-button" (mousedown)="onDragStart($event)" (touchstart)="onDragStart($event)">
    @if (!hideValues) {
      <div class="slider-tooltip">
        <div #tooltipContent class="tooltip-content">
          <span class="tooltip-value">{{value}}@if (showPercentSign) {
            <span>%</span>
          }</span>
        </div>
        <div #tooltipArrow class="tooltip-arrow"></div>
      </div>
    }
    <div #thumbEl class="thumb-icon"></div>
  </div>
</div>
<div class="tickmarks" #tickmarksEl [attr.disabled]="disabled ? '' : null">
  @for (tickmark of allTickmarks; track tickmark.value) {
    <div class="tickmark">
      <div class="tickmark-line"></div>
      @if (tickmark.label && !hideValues) {
        <div class="tickmark-label">{{tickmark.label}}</div>
      }
    </div>
  }
</div>
@for (tickmark of highlightedValues; track $index) {
  <div #highlightedValueTickmark class="highlightedValueTickmark">
    <cs-icon name="caret-up"></cs-icon>
  </div>
}